import { CreateDeleteAttachmentsDto } from '../../spdCore/autogenerated/spdApiClient';
import { newAttachmentForObject } from '../../spdCore/contexts/AttachmentContext';
import { AttachmentType } from '../../spdCore/validation/schemas';

import { NewFile } from './DragNDropFiles';

export const convertUploadedFilesToAttachments = (
  uploadedFiles: NewFile[],
  filesToDelete: string[],
  objectId: string,
  ObjectType: AttachmentType,
): CreateDeleteAttachmentsDto => {
  const attachmentsToAdd = uploadedFiles.map(att => {
    const attachment = newAttachmentForObject(ObjectType, objectId);
    return {
      ...attachment,
      name: att.name,
      file: att.content.toString('base64'),
    };
  });
  return {
    attachmentsToAdd: attachmentsToAdd,
    attachmentsToDelete: filesToDelete,
  };
};
